// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import { getPerformance } from "firebase/performance";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBIix3cn_bK1rsPrMOCtGgPcuZy_JaZbaI",
  authDomain: "beta-log.firebaseapp.com",
  projectId: "beta-log",
  storageBucket: "beta-log.firebasestorage.app",
  messagingSenderId: "932372658119",
  appId: "1:932372658119:web:1cbf78fee7b51ddb8c8be2",
  measurementId: "G-Z9CPTBPF64",
};

let app;
if (!firebase.apps.length) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app(); // Se já estiver inicializado, use a instância existente
}

const analytics = firebase.analytics();
const perfomance = getPerformance(app);
// const messaging = getMessaging(app);

export { analytics, perfomance };
